import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import Seo from '@/components/base/Seo';
import { mockFaqs } from '@/mocks/faqs';
import Hero from './components/Hero';
import TrendingBoard from './components/TrendingBoard';
import CategorySection from './components/CategorySection';
import LatestFeed from './components/LatestFeed';
import VoicesSection from './components/VoicesSection';
import FaqSection from './components/FaqSection';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '网报吃瓜',
    url: 'https://yuanfenq.cn',
    email: 'hello@wangbaochigua.com',
    description: '汇集网络热点评论、网友热议与不同立场的舆情观察站。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '网报吃瓜',
    url: 'https://yuanfenq.cn',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://yuanfenq.cn/topics?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: mockFaqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: { '@type': 'Answer', text: faq.a },
    })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="网报吃瓜 | 网报吃瓜网友热议持续更新，网报吃瓜评论与看法都在围观中"
        description="汇集网报吃瓜评论、网友热议、讨论与看法，评论区主流情绪和大众态度一眼看出。遇到事件不知道从哪入手，先看这里透出的讨论方向与不同立场，快速跟住舆情风向。"
        keywords="网报吃瓜,网报吃瓜网友,网报吃瓜热议,网报吃瓜评论,网报吃瓜讨论,网报吃瓜看法,网报吃瓜态度"
        path="/"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <Hero />
        <TrendingBoard />
        <CategorySection />
        <LatestFeed />
        <VoicesSection />
        <FaqSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}